module.exports = __webpack_public_path__ + "577edf297d05c206cca2ecfed6d80f8e.svg";